/* eslint-disable no-useless-constructor */
/* eslint-disable react/prefer-stateless-function */
import classNames from 'classnames';
import React from 'react';
import ReactDOM from 'react-dom';
import style from './record-guide.css';

class RecordGuide extends React.Component {
    constructor (props) {
        super(props);
    }
    componentDidMount () {
        this.create();
    }
    componentWillUnmount () {
        this.destory();
    }
    create () {
        this.divRef = document.createElement('div');
        ReactDOM.render(<div className={style.xhRecordGuide} >
            <div
                className={classNames({
                    [style.xhGuideStep1]: true,
                    [style.xhGuideStepWin]: navigator.appVersion.indexOf('Win') !== -1
                })}
            >
                <div className={style.xhGuideTop}>
                    <div className={style.xhGuideStepNum}>{1}</div>
                    <span>{'选择要录制的屏幕画面'}</span>
                </div>
                <div
                    className={classNames({
                        [style.xhGuideBody]: true,
                        [style.xhGuideBodyWin]: navigator.appVersion.indexOf('Win') !== -1
                    })}
                />
                <div className={style.xhGuideBodyArrowRight} />
            </div>
            <div
                className={classNames({
                    [style.xhGuideStep2]: true,
                    [style.xhGuideStepWin]: navigator.appVersion.indexOf('Win') !== -1
                })}
            >
                <div className={style.xhGuideTop}>
                    <div className={style.xhGuideStepNum}>{2}</div>
                    <span>{'选中屏幕画面后，点击【分享】按钮'}</span>
                </div>
                <div
                    className={classNames({
                        [style.xhGuideBody]: true,
                        [style.xhGuideBodyWin]: navigator.appVersion.indexOf('Win') !== -1
                    })}
                />
                <div className={style.xhGuideBodyArrowLeft} />
            </div>
        </div>, this.divRef);
        document.body.appendChild(this.divRef);
    }
    destory () {
        if (this.divRef) {
            document.body.removeChild(this.divRef);
            this.divRef = null;
        }
    }
    render () {
        return null;
        // (
        //     <div className={style.xhRecordGuide} >
        //         <div className={style.xhGuideStep1}>
        //             <div className={style.xhGuideTop}>
        //                 <div className={style.xhGuideStepNum}>{1}</div>
        //                 <span>{'点击选中右侧窗口'}</span>
        //             </div>
        //             <div
        //                 className={classNames({
        //                     [style.xhGuideBody]: true,
        //                     [style.xhGuideBodyWin]: navigator.appVersion.indexOf('Win') !== -1
        //                 })}
        //             >
        //                 <div className={style.xhGuideBodyChoose} />
        //                 <div className={style.xhGuideBodyArrowRight} />
        //             </div>
        //         </div>
        //         <div className={style.xhGuideStep2}>
        //             <div className={style.xhGuideTop}>
        //                 <div className={style.xhGuideStepNum}>{2}</div>
        //                 <span>{'选中窗口后，点击分享'}</span>
        //             </div>
        //             <div
        //                 className={classNames({
        //                     [style.xhGuideBody]: true,
        //                     [style.xhGuideBodyWin]: navigator.appVersion.indexOf('Win') !== -1
        //                 })}
        //             >
        //                 <div className={style.xhGuideBodyChoose} />
        //                 <div className={style.xhGuideBodyArrowLeft} />
        //             </div>
        //         </div>
        //     </div>
        // );
    }
}
RecordGuide.propTypes = {

};

export default RecordGuide;
